import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Moves keyboard focus to the `#main-content` element on every route change
 * so keyboard and screen-reader users start at the top of the new page rather
 * than being stranded in the navigation.
 */
export function useRouteFocusReset(): void {
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);

  useEffect(() => {
    if (prevPathRef.current === location.pathname) return;
    prevPathRef.current = location.pathname;

    // Small delay to let the new page render before moving focus.
    const id = requestAnimationFrame(() => {
      const mainEl = document.getElementById('main-content');
      if (mainEl) {
        mainEl.focus({ preventScroll: false });
      }
    });

    return () => cancelAnimationFrame(id);
  }, [location.pathname]);
}
